// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:24
import { CStampProcedure_abstract } from './../abstract/SagaSchema/CStampProcedure_abstract';
export class CStampProcedure extends CStampProcedure_abstract {}
